<div class="bmc-ldap-attributes">
    <div class="bmc-ldap-attributes__title">
        <label>{{ 'LDAP.DEFAULT_VALUES_DESCRIPTION' | translate }}</label>
    </div>
    <div class="bmc-ldap-attributes__add-panel">
        <label class="bmc-ldap-attributes__add-panel__text">{{ 'LDAP.TITLE_DEFAULT_VALUES' | translate }}</label>
        <bzg-button-primary (click)="addDefaultValue()">
            <svg class="bz-icon-svg bz-icon-svg--16">
                <use href="#icon-plus"></use>
            </svg>
            {{ 'LDAP.ADD_DEFAULT_VALUE' | translate }}
        </bzg-button-primary>
    </div>
    <div class="bmc-ldap-attributes__list">
        <div class="bmc-ldap-attributes__list__header">
            <label class="bmc-ldap-attributes__list__header__left">{{ 'LDAP.BIZAGI_ATTR' | translate }}</label>
            <label class="bmc-ldap-attributes__list__header__right">{{ 'LDAP.DISPLAY_VALUE' | translate }}</label>
        </div>
        <div *ngIf="isloading" class="bmc-ldap-security__loader">
            <bounce></bounce>
        </div>
        <ul class="bmc-ldap-attributes__list__items">
            <li *ngFor="let defaultp of defaults" class="bmc-ldap-attributes__list__item">
                <bzg-select class="bmc-ldap-attributes__list__item__key bz-space--inline-m" [placeholder]="'LDAP.SELECT_ATTRIBUTE' | translate" [value]="defaultp.key" (valueChange)="changeValueMapping($event, defaultp.position)">
                    <bzg-option *ngFor="let item of userProperties" [value]="item">
                        {{item.value}}
                    </bzg-option>
                </bzg-select>
                <bzg-input class="bmc-ldap-attributes__list__item__value bz-space--inline-m"
                    [placeholder]="'LDAP.TYPE_A_VALUE' | translate" [(ngModel)]="defaultp.value"
                    (change)="changeTextMapping($event.target.value, defaultp.position)"></bzg-input>
                <div class="bmc-ldap-attributes__list__item__delete-icon" (click)="deleteDefaultValue(defaultp)">
                    <svg class="bz-icon-svg bz-icon-svg--16">
                        <use href="#icon-delete"></use>
                    </svg>
                </div>
            </li>
        </ul>
    </div>
</div>